import {Component,OnInit, ElementRef, HostListener} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import { DOCUMENT } from "@angular/platform-browser";
import { BsDropdownModule } from 'ngx-bootstrap';
import {Validators, FormGroup, FormArray, FormBuilder} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ithera-topnav',
  templateUrl: './top-navigation.component.html'
})
export class TopNavComponent {

  // loginForm: FormGroup;
  // searchForm: FormGroup;
  message: string = '';
  isCollapsed = true;
  checkSearch = false;
  txtsearch: string;
  public searchForm: FormGroup;
  public screenWidth: any;

  constructor(public _authService: AuthService,
              private _router: Router,
              private _formBuilder: FormBuilder,
              private _el: ElementRef,
              private activatedRoute: ActivatedRoute) {

                this.searchForm = this._formBuilder.group({

                  txtsearch: [''],
                });
    // this.loginForm = _formBuilder.group({
    //   'username': ['', Validators.required],
    //   'password': ['', Validators.required]
    // });

    // this.searchForm = _formBuilder.group({
    //   'searchStr': ['', Validators.required]
    // });

  }

  // login() {
  //   console.log(this.loginForm.valueOf());
  //   this._authService
  //     .authenticate(this.loginForm.value.username, this.loginForm.value.password)
  //     .catch(errorMessage => this.message = errorMessage)
  //     .then(() => {
  //       if (this._authService.isAuthenticated()) {
  //         this._router.navigate(['/members']);
  //       }
  //     });
  // }

  // search() {
  //   //need to change the logic for search this._router.navigate(['/searchresults', {searchStr: this.searchForm.value.searchStr}])
  // }

   logout() {
    this._authService.logout();
    this._router.navigate(['/home' , { logout: '0' } ]);
  }

  ngOnInit(){
    this.searchForm = this._formBuilder.group({

      txtsearch: [''],
    });
  }


  onHidden(): void {
    console.log('Dropdown is hidden');
    if(this.checkSearch == false){
    this._el.nativeElement.querySelector('.dropdown-menu').classList.remove('show');
    this._el.nativeElement.querySelector('.dropdown-menu').classList.remove('dropdown-menuFix');
    this.checkSearch = false;
    }
  }
  onShown(): void {
    console.log('Dropdown is shown');
    if(this.checkSearch == true){
    this._el.nativeElement.querySelector('.dropdown-menu').classList.add('show');
    this._el.nativeElement.querySelector('.dropdown-menu').classList.remove('dropdown-menuFix');
    this.checkSearch = true;
    }

  }
  isOpenChange(): void {
    console.log('Dropdown state is changed');
  }

  onClickSearch(){
    console.log('Search clicked');
    if(this.checkSearch == false){
    this.checkSearch = true;
    this.onShown();
    }else{
      this.checkSearch = false;
      this.onHidden();
    }

  }

  submitSearch(){

    console.log('submit Search');
    console.log(this.searchForm.controls.txtsearch.value);

      this._router.navigate(['/search', { txtsearch: this.searchForm.controls.txtsearch.value } ], { relativeTo: this.activatedRoute, queryParams: { } } );

    }


    
  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.screenWidth = window.innerWidth;
    console.log(this.screenWidth + "Change screen width");

    if(this.screenWidth <= 992){
   //   this._el.nativeElement.querySelector('.dropdown-menu').classList.remove('dropdown-menu-right');
      //console.log(this.screenWidth + " width");

    }else if (this.screenWidth > 992) {

     // this._el.nativeElement.querySelector('.dropdown-menu').classList.add('dropdown-menu-right');
      //console.log(this.screenWidth + " width");
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/top-navigation/top-navigation.component.ts